exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#description[data-v-ea7d39de],#image[data-v-ea7d39de],#price[data-v-ea7d39de],#prodname[data-v-ea7d39de]{display:inline-block;vertical-align:top;margin-top:10px}#proditem[data-v-ea7d39de]{margin-left:20px;margin-bottom:20px;border-top:1px solid #d3d3d3}#prodname[data-v-ea7d39de]{width:200px}#description[data-v-ea7d39de]{width:300px}#price[data-v-ea7d39de]{width:100px}#image[data-v-ea7d39de]{width:250px}#categorydiv[data-v-ea7d39de]{margin-left:20px;font-family:Arial;font-size:20px;margin-bottom:40px}.button[data-v-ea7d39de]{border:1px solid gray;border-radius:4px;padding:10px;display:inline-block;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea7d39de","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Comp_ShowProducts.vue
// module id = 109
// module chunks = 0